import create from "zustand";
import { persist } from "zustand/middleware";

type InitStore = {
    logo: string,
    setLogo: (value:string) => void;
}
export const initialStore = create<InitStore>(persist(
    (set) => ({
        logo: '',
        setLogo: (value) => set(() => ({logo: value}))
    }),
    {name: "logo-image", getStorage: () => sessionStorage}
));
